import {
  FETCH_CATEGORIES_REQUEST,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_FAILURE,
  FETCH_CATEGORY_REQUEST,
  FETCH_CATEGORY_SUCCESS,
  FETCH_CATEGORY_FAILURE,
  UPDATE_CATEGORIES_REQUEST,
  UPDATE_CATEGORIES_FAILURE,
  UPDATE_CATEGORIES_SUCCESS,
  DELETE_CATEGORIES_REQUEST,
  DELETE_CATEGORIES_FAILURE,
  DELETE_CATEGORIES_SUCCESS,
  CLEAR_CATEGORY_ERRORS,    // Nouvelles imports
  CLEAR_CATEGORY_SUCCESS,
} from './actionTypes';

const initialState = {
  categories: [],
  category: null,
  loadingCategorie: false,
  errorCategory: null,
  categoryAdded: null
};

const Categories = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CATEGORIES_REQUEST:
      return {
        ...state,
        loadingCategorie: true,
        errorCategory: null,
        categoryAdded: false
      };
    case FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        loadingCategorie: false,
        categories: action.payload,
      };
    case FETCH_CATEGORIES_FAILURE:
      return {
        ...state,
        loadingCategorie: false,
        errorCategory: action.payload,
      };
    case FETCH_CATEGORY_REQUEST:
      return {
        ...state,
        loadingCategorie: true,
        errorCategory: null,
        categoryAdded: false
      };
    case FETCH_CATEGORY_SUCCESS:
      return {
        ...state,
        loadingCategorie: false,
        category: action.payload,
      };
    case FETCH_CATEGORY_FAILURE:
      return {
        ...state,
        loadingCategorie: false,
        errorCategory: action.payload,
      };
    case UPDATE_CATEGORIES_REQUEST:
      return {
        ...state,
        loadingCategorie: true,
        errorCategory: null,
        categoryAdded: false
      };
    case UPDATE_CATEGORIES_SUCCESS:
      return {
        ...state,
        loadingCategorie: false,
        category: null,
        categoryAdded: true
      };
    case UPDATE_CATEGORIES_FAILURE:
      return {
        ...state,
        loadingCategorie: false,
        errorCategory: action.payload,
      };
    case DELETE_CATEGORIES_REQUEST:
      return {
        ...state,
        loadingCategorie: true,
        errorCategory: null,
        categoryAdded: false
      };
    case DELETE_CATEGORIES_SUCCESS:
      return {
        ...state,
        categoryAdded: true,
        loadingCategorie: false,
        categories: state.categories.filter(category => category.id !== action.payload),
      };
    case DELETE_CATEGORIES_FAILURE:
      return {
        ...state,
        loadingCategorie: false,
        errorCategory: action.payload,
      };
    case CLEAR_CATEGORY_ERRORS:
      return {
        ...state,
        errorCategory: null,
      };
    case CLEAR_CATEGORY_SUCCESS:
      return {
        ...state,
        categoryAdded: null,
      };
      
    default:
      return state;
  }
};

export default Categories;